import React from 'react'

import NavigationMenuItemAddFolder from "../../../menu-items/project/add/menu-item-add-folder"
import NavigationMenuItemAddPage from "../../../menu-items/project/add/menu-item-add-page"
import NavigationMenuItemAddGroup from "../../../menu-items/project/add/menu-item-add-group"
import NavigationMenuItemAddLink from "../../../menu-items/project/add/menu-item-add-link"
import NavigationMenuItemAddEmbed from "../../../menu-items/project/add/menu-item-add-embed"
import {
    NavigationMenuInlineAddParams,
    NavigationMenuInlineAddType
} from "../../../menu-items/menu-add-with-popover/@types"
import NavigationMenuItemAddProductivity from "../../../menu-items/project/add/productivity/menu-item-add-productivity"
import NavigationMenuItemAddWhiteboard from "../../../menu-items/project/add/menu-item-add-whiteboard";

// const debug = "NavigationMenu_ProjectsInlineAdd"
const debug = false

type Props = {
    className?      : string

    type            : NavigationMenuInlineAddType
    level?          : number
    params          : NavigationMenuInlineAddParams
    parentId?       : ID

    callback        : callback
}

export default function NavigationMenu_ProjectsInlineAdd(props: Props) {

    debug && console.log(debug && "project inline add render() type=", props.type)

    switch (props.type) {

        case NavigationMenuInlineAddType.FOLDER:
            return <NavigationMenuItemAddFolder level       = {props.level}
                                                params      = {props.params}
                                                parentId    = {props.parentId}
                                                onAdded     = {props.callback}/>

        case NavigationMenuInlineAddType.PAGE:
            return <NavigationMenuItemAddPage level         = {props.level}
                                              parentId      = {props.parentId}
                                              templateId    = {props.params?.templateId}
                                              onAdded       = {props.callback}/>
        case NavigationMenuInlineAddType.WHITEBOARD:
            return <NavigationMenuItemAddWhiteboard level       = {props.level}
                                                    parentId    = {props.parentId}
                                                    onAdded     = {props.callback}/>

        case NavigationMenuInlineAddType.GROUP:
            return <NavigationMenuItemAddGroup level    = {props.level}
                                               parentId = {props.parentId}
                                               onAdded  = {props.callback}/>

        case NavigationMenuInlineAddType.LINK:
            return <NavigationMenuItemAddLink level     = {props.level}
                                              parentId  = {props.parentId}
                                              onAdded   = {props.callback}/>

        case NavigationMenuInlineAddType.EMBED:
            return <NavigationMenuItemAddEmbed level    = {props.level}
                                               parentId = {props.parentId}
                                               params   = {props.params}
                                               onAdded  = {props.callback}/>

        case NavigationMenuInlineAddType.TODOS:
        case NavigationMenuInlineAddType.GOALS:
        case NavigationMenuInlineAddType.FILES:
        case NavigationMenuInlineAddType.MEETINGS:
        case NavigationMenuInlineAddType.EXPENSES:
        case NavigationMenuInlineAddType.CHATS:
        case NavigationMenuInlineAddType.TASK_LIST:
        case NavigationMenuInlineAddType.TASK_BOARD:
            return <NavigationMenuItemAddProductivity type      = {props.type}
                                                      level     = {props.level}
                                                      parentId  = {props.parentId}
                                                      onAdded   = {props.callback}/>


    }

    return null
}
